// src/components/navbar/navbar.js
import React, { useContext, useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import AuthContext from '../../context/Auth/AuthContext';
import './navbar.css';
import "@fortawesome/fontawesome-free/css/all.css";
import { LogOut, ChevronDown } from 'lucide-react';

const Navbar = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);           // dropdown principal
  const [isCertidaoOpen, setIsCertidaoOpen] = useState(false);     // submenu 1
  const [isCalcOpen, setIsCalcOpen] = useState(false);              // submenu 2
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setIsCertidaoOpen(false);
        setIsCalcOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // fecha submenus quando o principal fecha
  useEffect(() => {
    if (!isOpen) {
      setIsCertidaoOpen(false);
      setIsCalcOpen(false);
    }
  }, [isOpen]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // helper para fechar tudo ao clicar num link
  const closeAll = () => {
    setIsOpen(false);
    setIsCertidaoOpen(false);
    setIsCalcOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="login-image">
        <NavLink to="/home" className="logo-text">
          CertiLaw
        </NavLink>
      </div>

      <div className="navbar__right">
        <ul className="nav-links">
          {/* Home */}
          <li className="nav-item">
            <NavLink
              to="/home"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Home
            </NavLink>
          </li>

          {/* Dropdown Área de trabalho */}
          <li className="dropdown nav-item" ref={dropdownRef}>
            <button
              className="dropdown-toggle nav-link"
              onClick={() => setIsOpen(o => !o)}
            >
              Área de trabalho
              <ChevronDown className={`dropdown-icon ${isOpen ? 'open' : ''}`} size={16} />
            </button>

            <ul className={`dropdown-menu ${isOpen ? 'open' : ''}`}>
              {/* Submenu: Certidão */}
              <li className="submenu">
                <button
                  className="submenu-toggle"
                  onClick={() => setIsCertidaoOpen(v => !v)}
                >
                  <span><i className="fas fa-folder-open"></i> Certidão</span>
                  <ChevronDown className={`submenu-icon ${isCertidaoOpen ? 'open' : ''}`} size={14} />
                </button>

                <ul className={`submenu-menu ${isCertidaoOpen ? 'open' : ''}`}>
                  <li>
                    <NavLink
                      to="/home/consult"
                      className={({ isActive }) => (isActive ? 'dropdown-item active' : 'dropdown-item')}
                      onClick={closeAll}
                    >
                      <i className="fas fa-search"></i> Consulta
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/home/dashboard"
                      className={({ isActive }) => (isActive ? 'dropdown-item active' : 'dropdown-item')}
                      onClick={closeAll}
                    >
                      <i className="fas fa-chart-line"></i> Relatório
                    </NavLink>
                  </li>
                </ul>
              </li>

              {/* Submenu: Cálculo Precatório */}
              <li className="submenu">
                <button
                  className="submenu-toggle"
                  onClick={() => setIsCalcOpen(v => !v)}
                >
                  <span><i className="fas fa-calculator"></i> Cálculo Precatório</span>
                  <ChevronDown className={`submenu-icon ${isCalcOpen ? 'open' : ''}`} size={14} />
                </button>

                <ul className={`submenu-menu ${isCalcOpen ? 'open' : ''}`}>
                  <li>
                    <NavLink
                      to="/home/calculation"
                      className={({ isActive }) => (isActive ? 'dropdown-item active' : 'dropdown-item')}
                      onClick={closeAll}
                    >
                      <i className="fas fa-file-invoice-dollar"></i> Cálculo Precatório
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/home/calculos"
                      className={({ isActive }) => (isActive ? 'dropdown-item active' : 'dropdown-item')}
                      onClick={closeAll}
                    >
                      <i className="fas fa-file-alt"></i> Solicitado
                    </NavLink>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>

        <div className="logout-section">
          <button onClick={handleLogout} className="nav-link">
            <LogOut className="logout-icon" size={20} />
            Sair
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
